export function getMediaFileName(item) {
    return item.name || item.filename || "名前不明";
}

export function getMediaDescription(item) {
    return item.description;
}